var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPinIconNotFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.7,
    "data-name": "Group 26774",
    transform: "translate(.851 .851)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.931 9.466c0 5.228-6.046 15.484-9.466 15.484-3.127 0-9.466-10.256-9.466-15.484a9.466 9.466 0 0 1 18.931 0Z",
    "data-name": "Path 24145"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.232,
    cy: 3.232,
    r: 3.232,
    "data-name": "Ellipse 581",
    transform: "translate(6.234 6.296)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPinIconNotFilled);
export default __webpack_public_path__ + "static/media/PinIconNotFilled.f01c54674d384f5de790f2a5ff6dd9a1.svg";
export { ForwardRef as ReactComponent };